import React, { useState, useEffect, useMemo, useCallback, memo } from 'react';
import EmptySection from 'components/lib/EmptySection';
import Accordion from '../lib/Accordion';
import Carousel from '../lib/Carousel';
import FlipCard from '../lib/FlipCard';
import FullPageText from '../lib/FullPageText';
import Multichoice from '../lib/Multichoice';
import Sortation from '../lib/Sortation';
import Matching from '../lib/Matching';
import TextAndImage from '../lib/TextAndImage';
import HotSpot from '../lib/HotSpot';
import FiveStarRating from '../lib/FiveStarRating';
import ResultsPage from '../lib/ResultsPage';
import ClickAndReveal from '../lib/ClickAndReveal';
import TopicPortal from '../lib/TopicPortal';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import pubSub from 'services/pubSub';

const InteractionComponents = {
  Accordion,
  Carousel,
  FlipCard,
  FullPageText,
  Multichoice,
  Sortation,
  Matching,
  TextAndImage,
  HotSpot,
  FiveStarRating,
  ResultsPage,
  ClickAndReveal,
  TopicPortal,
};

const getInteractionsOpen = createSelector(
  (state: any) => state.interactionsOpen,
  interactionsOpen => interactionsOpen
);

const getInteractionsSeen = createSelector(
  (state: any) => state.interactionsSeen,
  interactionsSeen => interactionsSeen
);

const Interactions = ({ interactions }) => {
  if (!interactions.length) {
    return <EmptySection />;
  }

  // const [interactionsOpen, setInteractionsOpen] = useState([
  //   interactions[0].id,
  // ]);

  // const interactionsOpen = useSelector(getInteractionsOpen);
  const interactionsSeen = useSelector(getInteractionsSeen);

  // console.log({ interactionsOpen });

  let next = true;

  // useEffect(() => {
  //   const pS = pubSub.subscribe('UPDATE_INTERACTIONS_OPEN', $ => {
  //     setInteractionsOpen($.interactionsOpen);
  //   });

  //   return () => {
  //     pS();
  //   };
  // }, []);

  const addNextInteractionToInteractionsSeen = interactions.filter(
    (i: any, index) => {
      return index === 0 || interactionsSeen.includes(i.id);
    }
  );

  if (addNextInteractionToInteractionsSeen.length !== interactions.length) {
    addNextInteractionToInteractionsSeen.push(
      interactions[addNextInteractionToInteractionsSeen.length]
    );
  }

  // console.log({ interactionsSeen, addNextInteractionToInteractionsSeen });

  return addNextInteractionToInteractionsSeen.map((interaction, i) => {
    const { id } = interaction;
    const Interaction = InteractionComponents[interaction.meta.subType];

    return (
      <Interaction
        key={id}
        blockId={id}
        isOpen={i === 0}
        aria-label={`Interaction: ${interaction.props.name}`}
        data={{
          ...interaction,
        }}
      />
    );
  });

  // return (
  //   <>
  //     {interactions
  //       .filter((_, i) => {
  //         if (window.dev() || i === 0) {
  //           return true;
  //         } else {
  //           if (!interactionsOpen.includes(_.id)) next = false;
  //           return next;
  //         }
  //       })

  //       .map((interaction, i) => {
  //         const { id } = interaction;
  //         const Interaction = InteractionComponents[interaction.meta.subType];

  //         return (
  //           <Interaction
  //             key={id}
  //             blockId={id}
  //             isFirstInteractionInTopic={i === 0}
  //             isOpen={interactionsOpen.includes(id) || i === 0}
  //             aria-label={`Interaction: ${interaction.props.name}`}
  //             data={{
  //               ...interaction,
  //             }}
  //           />
  //         );
  //       })}
  //   </>
  // );
};

export default Interactions;
